import { useCallback } from 'react';
import { useOpenDeeplink } from '../../../../hooks/useOpenDeeplink';
import { useRootStackNavigation } from '../../../../hooks/useRootNavigation';
import { useExperimentGroup } from '../../../../context/UserContext';

/**
 * - 검색 보조(SearchHelper) 페이지로 이동, 키보드 자동 노출
 */
export const useMoveToSearch = () => {
  const { openDeeplink } = useOpenDeeplink();
  const navigation = useRootStackNavigation();
  const isSearchExperiment = useExperimentGroup({
    sno: `EXP1592`,
    targetGroups: ['B'],
  });
  return useCallback(() => {
    if (isSearchExperiment) {
      navigation.push('SearchHelper', {
        show_keyboard: true,
      });
      return;
    }
    openDeeplink('ably://search?show_keyboard=true');
  }, [openDeeplink, isSearchExperiment, navigation]);
};
